import { environment } from "../constants/environment";
import { flowId } from "../constants/flowId";
import { uuid } from "../constants/uuid";
import { LogMessage } from "./log";

declare global {
  interface Window {
    lzGetCurrentLanguage?: () => string;
  }
}

export const format = (message: LogMessage): Record<string, unknown> | undefined => ({
  ...message,
  _time: Date.now(),
  appname: "help-support-flow",
  component: "XHS-FLOW",
  env: environment,
  locale: (typeof window?.lzGetCurrentLanguage === "function" && window?.lzGetCurrentLanguage()) || "en-US",
  page: flowId,
  uri: window.location.href,
  uuid,
});
